"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Indent = void 0;
/** Indents each line of a text block. */
class Indent {
    constructor(indent) {
        this.indent = indent;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    format(value, _parameters) {
        return value
            .split('\n')
            .map((line) => this.indent + line)
            .join('\n');
    }
}
exports.Indent = Indent;
//# sourceMappingURL=indent.js.map